<template>
    <div class="progress-bar">
        <p>{{dictionary.BookingFlowCommongProgressBarTitle}}</p>
                <ProgressBar :value="progress" :show-value="false"  :aria-label="dictionary.BookingFlowCommongProgressBarTitle"></ProgressBar>
    </div>
</template>
<script>
import ProgressBar from 'primevue/progressbar';

export default {
    name: "BookingProgress",
    components: {
        ProgressBar
    },
    props: ["progress"],
    data() {
        return {
            dictionary:[]
        };
    },
    created() {
        const vm = this;
        fetch("/umbraco/api/dictionaryapi/GetProgressDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
};
</script>
